import React, { useRef, useState } from "react";

import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
// import DatePicker from "react-datepicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import DownloadIcon from "@mui/icons-material/Download";
import {
  Box,
  Button,
  Divider,
  Fab,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  Stack,
  Tab,
  Tabs,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import "react-datepicker/dist/react-datepicker.css";
import AddIcon from "@mui/icons-material/Add";

// import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { useEffect } from "react";

import {
  addCategory,
  getCategory,
  GetDetailsExpense,
  GetDetailsExpenseXlsx,
  getPurchaseDetail,
} from "./expanceApi";

import {
  displayDateFormat,
  downloadXLSXFile,
  getEndOfMonth,
  getFirstDateOfCurrentMonthPayloadFormate,
  getFirstDateOfMonth,
  getLastDateOfCurrentMonthPayloadFormat,
  getLastDateOfMonth,
  getStartOfMonth,
  payloadDateFormat,
  swalAlertPopProps,
} from "../../utils/commonUtils";

import ExpenseModal from "./expenseModal";
import ExpenseItemCard from "./ExpenseItemsCard";
import { GETDETALS } from "../../utils/api";
import { getexpence } from "./expenseCustomApiHandlers";
import {
  datePickerOnChange,
  datePickerOnChangeEnd,
} from "./expenseDateFunctions";
import DynamicBreadcrumbs from "../../common/Breadcrumb";
import { CategoryPop } from "./category";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import TableReport from "./table";
import dayjs from "dayjs";
import { useTheme } from "@emotion/react";
import Stocks from "../stocks/stocks";
import Purchase from "../purchase/purchase";
import { useNavigate } from "react-router";
import { ArrowBackIcon } from "../../common/icon";
const Expense = ({ gridSize, Display }) => {
  const [open, setOpen] = useState(false);
  const [open_two, setOpen_two] = useState(false);
  const [startDateOpen, setStartDateOpen] = useState(false);
  const [endDateOpen, setEndDateOpen] = useState(false);
  const [date, setDate] = useState(null);
  const [displayEndDate, setDisplayEndDate] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [SelectedStartDate, setSelectedStartDate] = useState(
    dayjs(getStartOfMonth()),
  );
  const [startDateFormat, setstartDateFormat] = useState(
    dayjs(getStartOfMonth()).format("YYYY-MM-DD"),
  );
  const [endDate, setEndDate] = useState(dayjs().format("YYYY-MM-DD"));
  const datePickerRef = useRef();
  const datePickerRef2 = useRef();
  const [pagination, setPagination] = useState({
    page: 1,
    total: 1,
    records: 0,
    pageSize: 24,
  });
  const openDatePicker = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };
  const navigate = useNavigate();

  const [expence, setexpence] = useState([]);
  const [numberOfRecords, setNumberOfRecords] = useState(1);

  const [totalAmount, setTotalAmount] = useState(0);

  const [selectedCategory, setSelectedCategory] = useState({ name: "" });
  useEffect(() => {
    if (open === false) {
      setUpdateModalData();
    }
  }, [open]);

  const [billFilter, setBillFilter] = useState("cash");

  const [filters, setFilters] = useState([
    {
      name: "Raw Material",
      value: "Raw material",
    },
    { name: "Salary", value: "Salary" },
    {
      name: "Shop Maintenance",
      value: "Shop Maintenance",
    },
    { name: "Other", value: "Other" },
  ]);
  const [updateModalData, setUpdateModalData] = useState({
    date: null,
    id: "",
    expenseItemArrProps: [],
    filterByProp: "",
  });
  useEffect(() => {
    getexpence(
      {
        fromDate:
          startDateFormat ?? dayjs(getStartOfMonth()).format("YYYY-MM-DD"),
        toDate: endDate ?? dayjs(getLastDateOfMonth()).format("YYYY-MM-DD"),
        search: filterBy,
        page: 1,
        pageSize: pagination.pageSize,
      },
      GetDetailsExpense,
      setNumberOfRecords,
      setexpence,
      setTotalAmount,
    );
  }, [startDateFormat, endDate]);

  const handleChange = (event, value) => {
    getexpence(
      {
        fromDate: startDateFormat,
        toDate: endDate,
        search: filterBy,
        page: value,
        pageSize: pagination.pageSize,
      },
      GetDetailsExpense,
      setNumberOfRecords,
      setexpence,
      setTotalAmount,
    );

    setPagination({
      ...pagination,
      page: value,
    });
  };
  const [filterBy, setFilterBy] = useState("");
  useEffect(() => {
    console.log("datE ", payloadDateFormat());

    getexpence(
      {
        fromDate: startDateFormat,
        toDate: endDate,
        search: filterBy,
        page: 1,
        pageSize: pagination.pageSize,
      },
      GetDetailsExpense,
      setNumberOfRecords,
      setexpence,
      setTotalAmount,
    );

    // setDate()
    // setSelectedStartDate(getFirstDateOfMonth())
  }, []);

  const businessChooseTab = useSelector(
    (state) => state.reducer.businessChooseTab,
  );

  useEffect(() => {
    console.log(
      "SelectedStartDate ",
      SelectedStartDate,
      " ",
      getStartOfMonth(),
    );
  }, [SelectedStartDate]);
  const [listChategory, setListChategory] = useState([]);
  const [value, setValue] = useState("expense");
  const [SelectedEndDate, setSelectedEndDate] = useState(dayjs());
  useEffect(() => {
    getCategory((da) => {
      console.log("getCategory ", da?.data?.data?.list);
      setListChategory(da?.data?.data?.list);
    });
  }, []);

  const downloadXLSXFile = async (param) => {
    try {
      // const response = await axios.post(
      //   "user/api/v1/CounterSales/GetOverAllCounterSalesDetailsXlsx",
      //   param,
      //   {
      //     responseType: "blob",
      //   }
      // );

      const response = await GetDetailsExpenseXlsx(param, {
        responseType: "blob",
      });

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "file.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading XLSX file:", error);
    }
  };
  const theme = useTheme();
  const isAbove1440 = useMediaQuery("(min-width:1440px)");
  return (
    <>
      <Box
        sx={{
          p: { xs: "0px 10px", sm: "10px 10px", md: "17px 30px" },
          background: "#ede9ff",
          minHeight: "100vh",
        }}
      >
        {/* {!Display && <DynamicBreadcrumbs />} */}
        <Grid
          container
          spacing={2}
          sx={{
            padding: { xs: "10px", sm: "20px" },
            display: "flex",
            alignItems: "center",
          }}
        >
          <Grid item>
            <ArrowBackIcon
              sx={{ cursor: "pointer" }}
              onClick={() => navigate("/home")}
            />
          </Grid>
          <Grid
            item
            xs
            // sm={10}
            sm={businessChooseTab?.value == "ExpenceChategory" ? 6 : 10}
            md={businessChooseTab?.value == "ExpenceChategory" ? 7 : 10}
            lg={
              businessChooseTab?.value == "ExpenceChategory"
                ? isAbove1440
                  ? 8
                  : 8
                : 10
            }
          >
            <Box
              sx={{
                background:
                  "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
                padding: { xs: "10px", sm: "10px 20px" },
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderRadius: 2,
                color: "#01008B",
                textAlign: "left",
                fontFamily: "'Montserrat', sans-serif",
                fontWeight: 500,
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  fontWeight: 500,
                }}
              >
                {/* {businessChooseTab?.value === "expense"
                  ? "Expense"
                  : Display
                  ? "Expense"
                  : "Expense Category"} */}
                {businessChooseTab?.value === "expense"
                  ? "Expense"
                  : businessChooseTab?.value === "stock"
                    ? "Stock"
                    : businessChooseTab?.value === "Purchase"
                      ? "Purchase"
                      : Display
                        ? "Expense"
                        : "Expense Category"}
              </Typography>
            </Box>
          </Grid>

          {businessChooseTab?.value === "ExpenceChategory" && (
            <Grid item xs={12} sm={5} md={4} lg={isAbove1440 ? 3 : 3}>
              <Button
                variant="contained"
                onClick={() => {
                  setSelectedCategory({ name: "" });
                  setIsEdit(false);
                  setOpen_two(true);
                }}
                fullWidth
                sx={{
                  height: "40px",
                  backgroundColor: "#14008B",
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
                endIcon={<AddIcon />}
              >
                Add Expense Category
              </Button>
            </Grid>
          )}
        </Grid>

        {(businessChooseTab?.value == "expense" || Display) && (
          <Grid
            container
            spacing={2}
            sx={{
              display: "flex",
              marginTop: "20px",
              padding: { xs: "10px", sm: "0 20px" }, // Padding responsive
            }}
          >
            <Grid container spacing={2} sx={{ padding: "0 20px" }}>
              <Grid item xs={12} sm={6} md={5}>
                {" "}
                <TextField
                  label="Date"
                  size="small"
                  value={
                    SelectedStartDate && SelectedEndDate
                      ? `${SelectedStartDate.format?.("DD-MM-YYYY") || ""} to ${
                          SelectedEndDate.format?.("DD-MM-YYYY") || ""
                        }`
                      : SelectedStartDate
                        ? `${SelectedStartDate.format?.("DD-MM-YYYY") || ""}`
                        : ""
                  }
                  id="datepickerfield"
                  placeholder="Select date range"
                  InputProps={{
                    readOnly: true,
                    endAdornment: (
                      <CalendarMonthIcon
                        sx={{
                          cursor: "pointer",
                          mr: 1,
                        }}
                        onClick={() => setStartDateOpen(true)}
                      />
                    ),
                    sx: {
                      background: "#fff",
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      borderRadius: 1,
                      cursor: "pointer",
                      fontFamily: "'Montserrat', sans-serif",
                      fontWeight: 500,
                      height: "40px",
                      border: "none",
                      "& fieldset": { border: "none" },
                    },
                  }}
                  onClick={() => setStartDateOpen(true)}
                  sx={{
                    width: "100%",
                    height: "40px",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                />
                <Box sx={{ position: "relative" }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      open={startDateOpen}
                      onOpen={() => setStartDateOpen(true)}
                      onClose={() => setStartDateOpen(false)}
                      value={SelectedStartDate}
                      onChange={(val) => {
                        datePickerOnChange(
                          val,
                          setDate,
                          setstartDateFormat,
                          setSelectedStartDate,
                          setStartDateOpen,
                          setEndDateOpen,
                        );
                      }}
                      maxDate={SelectedEndDate || undefined}
                      slotProps={{
                        popper: {
                          placement: "bottom-start",
                          anchorEl: document.querySelector("#datepickerfield"),
                          sx: { zIndex: 1500 },
                        },
                        textField: { style: { display: "none" } },
                      }}
                    />
                  </LocalizationProvider>

                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      open={endDateOpen}
                      onOpen={() => setEndDateOpen(true)}
                      onClose={() => setEndDateOpen(false)}
                      value={SelectedEndDate}
                      onChange={(val) => {
                        datePickerOnChangeEnd(
                          val,
                          setEndDateOpen,
                          setSelectedEndDate,
                          setDisplayEndDate,
                          setEndDate,
                        );
                      }}
                      minDate={SelectedStartDate || undefined}
                      slotProps={{
                        popper: {
                          placement: "bottom-start",
                          anchorEl: document.querySelector("#datepickerfield"),
                          sx: { zIndex: 1500 },
                        },
                        textField: { style: { display: "none" } },
                      }}
                    />
                  </LocalizationProvider>
                </Box>
              </Grid>

              <Grid item xs={12} sm={6} md={5}>
                <FormControl
                  sx={{
                    width: "100%",
                    position: "relative",
                    height: "40px",
                    border: "none",
                    "& fieldset": { border: "none" },
                  }}
                  size="small"
                >
                  <InputLabel
                    id="demo-simple-select-label"
                    sx={{
                      position: "absolute",
                      top: "0",
                      height: "40px",

                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                  >
                    Select Category
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={filterBy}
                    sx={{
                      backgroundColor: "white",
                      height: "40px",
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                    // size="small"
                    label="Category "
                    onChange={(e) => {
                      setFilterBy(e.target.value);
                      getexpence(
                        {
                          fromDate: startDateFormat,
                          toDate: endDate,
                          search: e.target.value,
                          page: 1,
                          pageSize: pagination.pageSize,
                        },
                        GetDetailsExpense,
                        setNumberOfRecords,
                        setexpence,
                        setTotalAmount,
                      );
                    }}
                  >
                    {listChategory.map((item, index) => {
                      return (
                        <MenuItem value={item.name} key={"option" + index}>
                          {item.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>

                <Box
                  sx={{
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                ></Box>
              </Grid>
              <Grid item xs={12} sm={12} md={2}>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={() => {
                    downloadXLSXFile({
                      fromDate: startDateFormat,
                      toDate: endDate,
                      search: filterBy,
                      page: 1,
                      pageSize: pagination.pageSize,
                    });
                  }}
                  sx={{
                    height: "40px",
                    backgroundColor: "#14008B",
                    padding: 0,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                  endIcon={<DownloadIcon />}
                >
                  Download
                </Button>
              </Grid>
            </Grid>
            <Grid
              container
              spacing={2}
              sx={{
                padding: { xs: "10px", sm: "20px" },
                paddingLeft: { xs: "10px", sm: "36px" },
                display: "flex",
                justifyContent: "space-between",
                // alignItems: "center",
                // mt: { xs: 1, sm: 1 },
              }}
            >
              {/* Total Amount */}
              <Grid
                item
                xs={12}
                sm={6}
                md={5}
                lg={isAbove1440 ? 3 : 4}
                sx={{
                  // padding: "5px 16px",
                  fontWeight: 500,
                  backgroundColor: "#CCCCFF",
                  mt: { xs: 2, sm: 2 },
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  // pl: 3,
                  ml: { xs: 3, sm: 0 },
                  //  px: 2, // optional horizontal padding
                  py: { md: 0, sm: 0, xs: 0 },
                  // textAlign: { xs: "center", sm: "left" },
                }}
              >
                <Typography
                  component="div"
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: { xs: "center", sm: "flex-start" },
                    mb: { xs: 1, sm: 1 },
                    // ml: { xs: 2, sm: 1 },
                    // alignItems: "center",
                    mt: { xs: 0, sm: 0 },
                    color: "#00008B",
                  }}
                >
                  <Typography
                    component="span"
                    sx={{
                      fontWeight: 500,
                      // ml:2,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                  >
                    Total Bills Amount (₹):
                  </Typography>
                  <Typography
                    component="span"
                    sx={{
                      fontWeight: "bold",
                      marginLeft: "8px",
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                  >
                    {totalAmount?.toFixed(2)}
                  </Typography>
                </Typography>
              </Grid>

              {/* Add Expenses Button */}
              {!gridSize && (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  sx={{
                    // pl: 3,
                    ml: { xs: 1, sm: 0 },
                    mt: { xs: 0, sm: "6px", md: 0 },
                    // textAlign: { xs: "center", sm: "left" },
                  }}
                >
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={() => setOpen(true)}
                    sx={{
                      height: "40px",
                      backgroundColor: "#14008B",
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                    endIcon={<AddIcon />}
                  >
                    Add Expenses
                  </Button>
                </Grid>
              )}
            </Grid>

            <Grid container sx={{ marginX: { xs: "0px", sm: "20px" } }}>
              {/* {expence?.map((item, i) => {
                return (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    lg={4}
                    key={"expence" + i}
                    sx={{ p: "5px", borderRight: "3px solid #dfdfdf" }}
                  >
                    <ExpenseItemCard
                      item={item}
                      onClick={(data) => {
                        console.log("Data ", data);
                        if (gridSize) {
                          return;
                        }
                        setOpen(true);
                        setUpdateModalData({
                          date: data?.date,
                          id: data?.id,
                          expenseItemArrProps: data?.expenseDetails,
                          filterByProp: data?.category,
                        });
                      }}
                    />
                  </Grid>
                );
              })} */}

              <TableReport
                salesData={[]}
                colName={[]}
                setOpen={setOpen}
                setUpdateModalData={setUpdateModalData}
                updateModalData={updateModalData}
                data={expence ?? []}
              />
            </Grid>

            {/* <Grid container sx={{ pt: "10px" }}>
              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Pagination
                  count={
                    Number.isInteger(numberOfRecords / pagination.pageSize)
                      ? numberOfRecords / pagination.pageSize
                      : parseInt(numberOfRecords / pagination.pageSize) + 1
                  }
                  page={pagination.page}
                  onChange={handleChange}
                />
              </Grid>
            </Grid> */}

            <ExpenseModal
              listChategory={listChategory}
              open={open}
              setOpen={setOpen}
              updateModalData={updateModalData}
              idProp={updateModalData?.id}
              filterByProp={updateModalData?.filterByProp}
              expenseItemArrProps={updateModalData?.expenseItemArrProps}
              getPurchase={() => {
                getexpence(
                  {
                    fromDate: startDateFormat,
                    toDate: endDate,
                    search: filterBy,
                    page: 1,
                    pageSize: pagination.pageSize,
                  },
                  GetDetailsExpense,
                  setNumberOfRecords,
                  setexpence,
                  setTotalAmount,
                );
              }}
            />
          </Grid>
        )}
        {businessChooseTab?.value == "ExpenceChategory" && (
          <Grid
            container
            spacing={2}
            sx={{
              // sx={{displa}
              display: "flex",
              maxHeight: "calc(100vh - 60px)",
              paddingTop: "50px",
              paddingX: "10px",
            }}
          >
            <Box
              sx={{
                width: "100%",
                marginLeft: "10px",
                backgroundColor: "white",
                borderRadius: "9px",
                padding: "20px",
              }}
            >
              <Grid
                container
                spacing={1}
                sx={{
                  overflowY: "auto",
                  maxHeight: "70vh",
                  paddingRight: { sm: "20px", xs: "0px" },
                }}
              >
                {listChategory?.map((item, i) => {
                  return (
                    <Grid item xs={12} key={"expence" + i}>
                      <ExpenseItemCard
                        item={item}
                        width={12}
                        onClick={(data) => {
                          console.log("alon/AddExpensesCategory ", item);
                          setOpen_two(true);
                          setIsEdit(true);
                          setSelectedCategory({ ...item });
                        }}
                      />
                    </Grid>
                  );
                })}
              </Grid>
            </Box>
            {/* ------------------------ */}
            <Grid container sx={{ pt: "10px" }}>
              <Grid
                item
                xs={12}
                sx={{
                  // bgcolor: "red",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {/* <Stack direction="row" justifyContent="space-around" sx={{ mt: 2 }}> */}
                <Pagination
                  count={
                    Number.isInteger(numberOfRecords / pagination.pageSize)
                      ? numberOfRecords / pagination.pageSize
                      : parseInt(numberOfRecords / pagination.pageSize) + 1
                  }
                  page={pagination.page}
                  onChange={handleChange}
                />
                {/* </Stack> */}
              </Grid>
              {/* <Grid item xs={4}></Grid> */}
            </Grid>
            {/* 
        <ExpenseModal
          open={open}
          setOpen={setOpen}
          updateModalData={updateModalData}
          idProp={updateModalData?.id}
          filterByProp={updateModalData?.filterByProp}
          expenseItemArrProps={updateModalData?.expenseItemArrProps}
          getPurchase={() => {
            getexpence(
              {
                fromDate: startDateFormat,
                toDate: endDate,
                search: filterBy,
                page: 1,
                pageSize: pagination.pageSize,
              },
              GetDetailsExpense,
              setNumberOfRecords,
              setexpence,
              setTotalAmount
            );
          }}
        />
         */}
            <CategoryPop
              open={open_two}
              setOpen={setOpen_two}
              selectedCategory={selectedCategory}
              setSelectedCategory={setSelectedCategory}
              callback={(payload) => {
                if (selectedCategory.name == "") {
                  Swal.fire({
                    title: "",
                    text: "Invalid",
                    icon: "error",

                    ...swalAlertPopProps,
                  });
                  return;
                }
                addCategory(payload, (data) => {
                  console.log("selectedCategory");
                  setSelectedCategory({ name: "" });

                  getCategory((da) => {
                    console.log("getCategory ", da?.data?.data?.list);
                    setListChategory(da?.data?.data?.list);
                  });
                });
              }}
            />
          </Grid>
        )}

        <Grid item xs={12}>
          {businessChooseTab?.value == "stock" && <Stocks />}
          {businessChooseTab?.value == "Purchase" && <Purchase />}
        </Grid>
      </Box>
    </>
  );
};

export default Expense;
